import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../app/consts";

export class EventChartCourtRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number, id: Number, isShallow: Boolean) {
    super(width, height);

    const source = isShallow ? "_fb" : "";
    this.resourceName = `${this.resourceName}/court/${id}${source}`;
    this.version = 1
    this.c = null

  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}